<template>
  <div class="public-img">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "PublicImg"
};
</script>

<style lang="scss" scoped>
.public-img {
  margin-left: 30px;
  margin-right: 30px;
  margin-bottom: 30px;
  img {
    width: 100%;
    height: 100%;
  }
}
</style>
